import i18n from '@/utils/i18n';
import React from 'react';
import { AnimatedSkeletonLoader } from '@usepepper/ui/atoms/animated-skeleton-loader';
import { createStyles } from '@/contexts/theme-context';
import { ITEM_CARD_MIN_WIDTH } from '@/experiences/sales-portal/domain/accounts/screens/account-detail/components/account-detail-items-of-interest';
import { View } from 'react-native';

const ROW_COUNT = 3;
const COLUMNS = 2;
const TITLE_HEIGHT = 12;
const TITLE_WIDTH = '70%';
const SUBTITLE_HEIGHT = 10;
const SUBTITLE_WIDTH = '45%';

export const AccountDetailItemsOfInterestSkeleton: React.FC = () => {
  const [styles, theme] = useStyles();
  const barRadius = theme.sk.radii.radiusRound;

  return (
    <View
      accessibilityLabel={i18n.t(
        'sales_portal.account_detail.items_of_interest.loading',
      )}
      accessibilityRole="progressbar"
      style={styles.itemsGrid}
    >
      {Array.from({ length: ROW_COUNT }).map((_, rowIndex) => (
        <View key={rowIndex} style={styles.itemRow}>
          {Array.from({ length: COLUMNS }).map((_, cellIndex) => (
            <View key={cellIndex} style={styles.itemCell}>
              <AnimatedSkeletonLoader
                borderRadius={theme.sk.radii.radiusMedium}
                height={theme.sk.spacing.space2xlarge}
                width={theme.sk.spacing.space2xlarge}
              />
              <View style={styles.itemDetails}>
                <AnimatedSkeletonLoader
                  borderRadius={barRadius}
                  height={TITLE_HEIGHT}
                  width={TITLE_WIDTH}
                />
                <AnimatedSkeletonLoader
                  borderRadius={barRadius}
                  height={SUBTITLE_HEIGHT}
                  width={SUBTITLE_WIDTH}
                />
              </View>
            </View>
          ))}
        </View>
      ))}
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  itemCell: {
    alignItems: 'center',
    flex: 1,
    flexDirection: 'row',
    gap: theme.sk.spacing.spaceSMedium,
    minWidth: ITEM_CARD_MIN_WIDTH,
  },
  itemDetails: {
    flex: 1,
    gap: theme.sk.spacing.spaceXsmall,
  },
  itemRow: {
    columnGap: theme.sk.spacing.space3xlarge,
    flexDirection: 'row',
    flexWrap: 'wrap',
    rowGap: theme.sk.spacing.spaceMedium,
  },
  itemsGrid: {
    rowGap: theme.sk.spacing.spaceMedium,
  },
}));
